export default __webpack_public_path__ + "static/media/logo_side.619dd780.svg";